// @ts-nocheck
export const localeCodes =  [
  "en",
  "us",
  "nl",
  "fr",
  "de",
  "it",
  "es",
  "pt",
  "br",
  "ja",
  "zh",
  "tr",
  "ko"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_GB_46json_5b87093a",
      load: () => import("#nuxt-i18n/5b87093a" /* webpackChunkName: "locale_en_GB_46json_5b87093a" */),
      cache: true
    }
  ],
  us: [
    {
      key: "locale_en_US_46json_7775058e",
      load: () => import("#nuxt-i18n/7775058e" /* webpackChunkName: "locale_en_US_46json_7775058e" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_NL_46json_0129c036",
      load: () => import("#nuxt-i18n/0129c036" /* webpackChunkName: "locale_nl_NL_46json_0129c036" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_FR_46json_8116594d",
      load: () => import("#nuxt-i18n/8116594d" /* webpackChunkName: "locale_fr_FR_46json_8116594d" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_DE_46json_309120e8",
      load: () => import("#nuxt-i18n/309120e8" /* webpackChunkName: "locale_de_DE_46json_309120e8" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_IT_46json_f044ecf9",
      load: () => import("#nuxt-i18n/f044ecf9" /* webpackChunkName: "locale_it_IT_46json_f044ecf9" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_ES_46json_cf28c561",
      load: () => import("#nuxt-i18n/cf28c561" /* webpackChunkName: "locale_es_ES_46json_cf28c561" */),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_PT_46json_87d51bfd",
      load: () => import("#nuxt-i18n/87d51bfd" /* webpackChunkName: "locale_pt_PT_46json_87d51bfd" */),
      cache: true
    }
  ],
  br: [
    {
      key: "locale_pt_BR_46json_f2a247f8",
      load: () => import("#nuxt-i18n/f2a247f8" /* webpackChunkName: "locale_pt_BR_46json_f2a247f8" */),
      cache: true
    }
  ],
  ja: [
    {
      key: "locale_ja_JP_46json_7b2ab865",
      load: () => import("#nuxt-i18n/7b2ab865" /* webpackChunkName: "locale_ja_JP_46json_7b2ab865" */),
      cache: true
    }
  ],
  zh: [
    {
      key: "locale_zh_CN_46json_6bb8f7c0",
      load: () => import("#nuxt-i18n/6bb8f7c0" /* webpackChunkName: "locale_zh_CN_46json_6bb8f7c0" */),
      cache: true
    }
  ],
  tr: [
    {
      key: "locale_tr_TR_46json_50351707",
      load: () => import("#nuxt-i18n/50351707" /* webpackChunkName: "locale_tr_TR_46json_50351707" */),
      cache: true
    }
  ],
  ko: [
    {
      key: "locale_ko_KR_46json_c3ddf4c3",
      load: () => import("#nuxt-i18n/c3ddf4c3" /* webpackChunkName: "locale_ko_KR_46json_c3ddf4c3" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/6b2f2c53" /* webpackChunkName: "config_vueI18nConfig_46ts_6b2f2c53" */)
]
export const normalizedLocales = [
  {
    code: "en",
    language: "en-GB",
    ogLocale: "en_GB",
    abbreviation: "en",
    name: "English (UK)",
    _hreflang: "en-GB",
    _sitemap: "en-GB"
  },
  {
    code: "us",
    language: "en-US",
    ogLocale: "en_US",
    abbreviation: "en",
    name: "English (US)",
    _hreflang: "en-US",
    _sitemap: "en-US"
  },
  {
    code: "nl",
    language: "nl-NL",
    ogLocale: "nl_NL",
    abbreviation: "nl",
    name: "Nederlands",
    _hreflang: "nl-NL",
    _sitemap: "nl-NL"
  },
  {
    code: "fr",
    language: "fr-FR",
    ogLocale: "fr_FR",
    abbreviation: "fr",
    name: "Français",
    _hreflang: "fr-FR",
    _sitemap: "fr-FR"
  },
  {
    code: "de",
    language: "de-DE",
    ogLocale: "de_DE",
    abbreviation: "de",
    name: "Deutsch",
    _hreflang: "de-DE",
    _sitemap: "de-DE"
  },
  {
    code: "it",
    language: "it-IT",
    ogLocale: "it_IT",
    abbreviation: "it",
    name: "Italiano",
    _hreflang: "it-IT",
    _sitemap: "it-IT"
  },
  {
    code: "es",
    language: "es-ES",
    ogLocale: "es_ES",
    abbreviation: "es",
    name: "Español",
    _hreflang: "es-ES",
    _sitemap: "es-ES"
  },
  {
    code: "pt",
    language: "pt-PT",
    ogLocale: "pt_PT",
    abbreviation: "pt",
    name: "Português",
    _hreflang: "pt-PT",
    _sitemap: "pt-PT"
  },
  {
    code: "br",
    language: "pt-BR",
    ogLocale: "pt_BR",
    abbreviation: "pt",
    name: "Português do Brasil",
    _hreflang: "pt-BR",
    _sitemap: "pt-BR"
  },
  {
    code: "ja",
    language: "ja-JP",
    ogLocale: "ja_JP",
    abbreviation: "ja",
    name: "日本語",
    _hreflang: "ja-JP",
    _sitemap: "ja-JP"
  },
  {
    code: "zh",
    language: "zh-CN",
    ogLocale: "zh_CN",
    abbreviation: "zh",
    name: "简体中文",
    _hreflang: "zh-CN",
    _sitemap: "zh-CN"
  },
  {
    code: "tr",
    language: "tr-TR",
    ogLocale: "tr_TR",
    abbreviation: "tr",
    name: "Türkçe",
    _hreflang: "tr-TR",
    _sitemap: "tr-TR"
  },
  {
    code: "ko",
    language: "ko-KR",
    ogLocale: "ko_KR",
    abbreviation: "ko",
    name: "한국어",
    _hreflang: "ko-KR",
    _sitemap: "ko-KR"
  }
]
/** client **/

/** client-end **/